import React from 'react'
import './student-onboarding-templates-menu.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import trashcan from '../../img/delete-blue.svg'
import pencil from '../../img/pencil-blue.svg'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const StudentOnboardingTemplatesMenu = ({setTemplatesMenu, addThisWorkflow, editExistingTemplate, setDeleteWarningPopup, createANewWorkflowTemplate}) => {
    const [templates, setTemplates] = React.useState([])

    React.useEffect(() => {
        axios.get(`${baseUrl}/studentworkflowtemplates`, myHeader)
        .then(res => setTemplates(res.data))
        .catch(err => console.log(err))
    }, [])

    const truncate = (str, n) => {
        if(str) {
            return str.length > n ? str.substr(0, n-1) + '...' : str 
        }
    }

    return(
        <div className='student-workflows-2022__templates-menu' onMouseLeave={() => setTemplatesMenu(false)}>
            {templates.length === 0 &&
                <div className='student-workflows-2022__templates__btn-wrapper darker-template-btn'>
                    <div className='student-workflows-2022__templates__name'>Loading Workflows</div>
                </div>
            }
            {templates.map((temp) => (
                <div key={temp.todoId} className='student-workflows-2022__templates__btn-wrapper'>
                    <div className='student-workflows-2022__templates__name' onClick={() => addThisWorkflow(temp.todoId)}>{truncate(temp.todoName, 34)}</div>
                    <img className="student-workflows-2022__templates__icon" id="student-workflows-2022__templates__icon-pencil" alt="trashcan" onClick={() => editExistingTemplate(temp.todoId)} src={pencil} />
                    {temp.todoId !== '86310799471e2' && <img className="student-workflows-2022__templates__icon" id="student-workflows-2022__templates__icon-can" alt="trashcan" onClick={() => setDeleteWarningPopup(temp.todoId)} src={trashcan} />}
                </div>
            ))}
            <div className='student-workflows-2022__templates__btn-wrapper darker-template-btn'>
                <div className='student-workflows-2022__templates__name' onClick={() => createANewWorkflowTemplate()}>+ Design New Template</div>
            </div>
        </div>
    )
}
export default StudentOnboardingTemplatesMenu